import React, {Component} from 'react';
import {Alert} from 'reactstrap';
import ItemUser from './ItemUser';
import {_getListUsers} from '../../../../../services/apis/AdminAffiliate';
import Pages from '../pagination/Pages';
import ModalWithdrawal from './ModalWithdrawal';
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"


const getInitPage = () => {
    const parsed = parseSearchQuery();
    return !!parsed.page ? parseInt(parsed.page, 10) : 1;
}

class AffiliateUserPage extends Component {
    state = {
        listUsers: [],
        error: '',
        total: 0,
        pages: {
            page: getInitPage(),
            limit: 10,
            maxPage: 1
        },
        withdrawal: {
            modal: false,
            user: {}
        }
    }

    componentDidMount() {
        this.getListUsers();
    }

    componentDidUpdate(preProps, preState) {
        const {page} = this.state.pages;
        if (preState.pages.page !== page) {
            this.getListUsers();
        }
    }


    getListUsers = () => {
        const {pages} = this.state;

        _getListUsers(pages)
            .then((result) => {
                if (result.success) {
                    this.setState({
                        listUsers: result.data.docs,
                        error: '',
                        pages: {
                            page: result.data.page,
                            limit: result.data.limit,
                            maxPage: result.data.pages,
                        },
                        total: result.data.total,
                    });
                } else {
                    this.setState({
                        error: result.message
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                });
            });
    }

    handleGoToPage = (index) => {
        const {limit, maxPage} = this.state.pages;
        changeQuerySearch({page: index});
        this.setState({
            pages: {
                page: index,
                limit,
                maxPage
            }
        });
    }

    toggleWithdrawal = () => {
        this.setState(prevState => ({
            withdrawal: {
                ...prevState.withdrawal,
                modal: !prevState.withdrawal.modal
            }
        }));
    }

    _refreshPage = () => {
        this.getListUsers();
    }

    transfersToAcc = (user) => {
        this.setState(prevState =>({
            withdrawal: {
                ...prevState.withdrawal,
                user,
            }
        }));

    }

    render() {
        const {listUsers, error, pages, withdrawal, total} = this.state;
        return (
            <div className="AffiliateUserPage">
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <h2>Users({total})</h2>
                <div className='affiliate-user-table'>
                    <div className='table-header'>
                        <div className='row table-row'>
                            <div className='col-2'>NAME</div>
                            <div className='col-3'>EMAIL</div>
                            <div className='col-1'>STATUS</div>
                            <div className='col-3'>PAYPAL</div>
                            <div className='col-1'>BALANCE</div>
                            <div className='col-2'>WITHDRAWAL</div>
                        </div>
                    </div>
                    <div className='table-body'>
                        {
                            listUsers.map((user) => {
                                return (
                                    <ItemUser
                                        key={user._id}
                                        user={user}
                                        transfersToAcc={this.transfersToAcc}
                                        onRefreshPage={this._refreshPage}
                                        toggleWithdrawal = {this.toggleWithdrawal}
                                    />
                                );
                            })
                        }
                    </div>
                </div>

                <ModalWithdrawal
                    onReloadPage={this.getListUsers}
                    withdrawal={withdrawal}
                    toggle={this.toggleWithdrawal}
                />

                <Pages
                    pages={pages}
                    handleGoToPage={this.handleGoToPage}
                />
            </div>
        );
    }
}

export default AffiliateUserPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/users/AffiliateUserPage.js